import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, vModelText as _vModelText, withDirectives as _withDirectives, createVNode as _createVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-0613f218"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "order_header"
};
const _hoisted_2 = {
  class: "status"
};
const _hoisted_3 = {
  key: 0,
  class: "address"
};
const _hoisted_4 = {
  class: "userInfo"
};
const _hoisted_5 = {
  class: "detail"
};
const _hoisted_6 = {
  class: "goods_info"
};
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "商品信息", -1));
const _hoisted_8 = {
  class: "goods_list"
};
const _hoisted_9 = {
  class: "title"
};
const _hoisted_10 = {
  class: "list"
};
const _hoisted_11 = ["onClick"];
const _hoisted_12 = {
  class: "over_card"
};
const _hoisted_13 = ["src"];
const _hoisted_14 = {
  class: "bottom"
};
const _hoisted_15 = {
  key: 0,
  class: "double"
};
const _hoisted_16 = {
  class: "title render-font-family"
};
const _hoisted_17 = {
  class: "field"
};
const _hoisted_18 = {
  class: "col"
};
const _hoisted_19 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "卡砖/卡夹费", -1));
const _hoisted_20 = {
  class: "col"
};
const _hoisted_21 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "寄存费", -1));
const _hoisted_22 = {
  key: 0,
  class: "col"
};
const _hoisted_23 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "运费", -1));
const _hoisted_24 = {
  key: 1,
  class: "col"
};
const _hoisted_25 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "合计发货费", -1));
const _hoisted_26 = {
  class: "field last"
};
const _hoisted_27 = {
  key: 0,
  class: "col"
};
const _hoisted_28 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "发货单号", -1));
const _hoisted_29 = {
  class: "order_no"
};
const _hoisted_30 = ["copyData"];
const _hoisted_31 = {
  key: 1,
  class: "col"
};
const _hoisted_32 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "申请发货时间", -1));
const _hoisted_33 = {
  key: 2,
  class: "col"
};
const _hoisted_34 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "支付时间", -1));
const _hoisted_35 = {
  key: 3,
  class: "col"
};
const _hoisted_36 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "支付方式", -1));
const _hoisted_37 = {
  key: 4,
  class: "col"
};
const _hoisted_38 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "支付流水", -1));
const _hoisted_39 = {
  class: "bottom"
};
const _hoisted_40 = {
  class: "btn_list"
};
const _hoisted_41 = ["onClick"];
const _hoisted_42 = {
  class: "deliverDialog"
};
const _hoisted_43 = {
  class: "top"
};
const _hoisted_44 = {
  key: 0,
  class: "pay_type"
};
const _hoisted_45 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "weixin"
}, "微信支付", -1));
const _hoisted_46 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "alipay"
}, "支付宝", -1));
const _hoisted_47 = {
  class: "btns"
};
const _hoisted_48 = ["innerHTML"];
const _hoisted_49 = ["src"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Error = _resolveComponent("Error");
  const _component_BigImage = _resolveComponent("BigImage");
  const _component_van_action_sheet = _resolveComponent("van-action-sheet");
  return $data.showError ? (_openBlock(), _createBlock(_component_Error, {
    key: 0,
    message: $data.showMessage
  }, null, 8, ["message"])) : (_openBlock(), _createElementBlock("div", {
    key: 1,
    class: _normalizeClass(['order_lists', 'render-hide-scroll', {
      'app': $data.env.isModianIos() || $data.env.isModianAndroid() || $data.env.isModianIosNew() || $data.env.isWxApp()
    }])
  }, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("i", {
    class: _normalizeClass([{
      'cancel': [20, 60].includes($data.order_detail.status)
    }, {
      'success': [10, 50].includes($data.order_detail.status)
    }])
  }, null, 2), _createElementVNode("p", null, _toDisplayString($options.getStatusTxt($data.order_detail.status)), 1)]), $data.order_detail.address ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, _toDisplayString($data.order_detail.address.address_name) + " " + _toDisplayString($data.order_detail.address.address_mobile), 1), _createElementVNode("div", _hoisted_5, _toDisplayString($data.order_detail.address.province) + " " + _toDisplayString($data.order_detail.address.city) + " " + _toDisplayString($data.order_detail.address.county) + " " + _toDisplayString($data.order_detail.address.street) + " " + _toDisplayString($data.order_detail.address.address), 1)])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_6, [_hoisted_7, _createElementVNode("p", null, "合计：" + _toDisplayString($data.order_detail.card_num) + "张", 1)])]), _createElementVNode("div", _hoisted_8, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.order_detail.activity_goods_infos, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: "item",
      key: index
    }, [_createElementVNode("div", _hoisted_9, _toDisplayString(item.activity_name), 1), _createElementVNode("div", _hoisted_10, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.card_infos, (carItem, cardIndex) => {
      return _openBlock(), _createElementBlock("div", {
        class: "list_item",
        key: cardIndex
      }, [_createElementVNode("div", {
        class: "bg",
        onClick: _withModifiers($event => $options.showBigImage(item.card_infos, cardIndex), ["stop"])
      }, [_createElementVNode("div", _hoisted_12, [_createElementVNode("img", {
        src: `${_ctx.$imgUrlFilter(carItem.card_img_url, 220)}`
      }, null, 8, _hoisted_13), _createElementVNode("div", _hoisted_14, _toDisplayString(carItem.level_name), 1), carItem.card_back_img_url ? (_openBlock(), _createElementBlock("div", _hoisted_15, "多图")) : _createCommentVNode("", true)])], 8, _hoisted_11), _createElementVNode("p", _hoisted_16, _toDisplayString(carItem.card_name), 1)]);
    }), 128))])]);
  }), 128))]), _createElementVNode("div", _hoisted_17, [_createElementVNode("div", _hoisted_18, [_hoisted_19, _createElementVNode("p", null, _toDisplayString($data.order_detail.clamp_fee || 0), 1)]), _createElementVNode("div", _hoisted_20, [_hoisted_21, _createElementVNode("p", null, _toDisplayString($data.order_detail.deposit_fee || 0), 1)]), $data.order_detail.postage_fee ? (_openBlock(), _createElementBlock("div", _hoisted_22, [_hoisted_23, _createElementVNode("p", null, _toDisplayString($data.order_detail.postage_fee), 1)])) : _createCommentVNode("", true), $data.order_detail.total_fee ? (_openBlock(), _createElementBlock("div", _hoisted_24, [_hoisted_25, _createElementVNode("p", null, _toDisplayString($data.order_detail.total_fee), 1)])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_26, [$data.order_detail.postage_order_no ? (_openBlock(), _createElementBlock("div", _hoisted_27, [_hoisted_28, _createElementVNode("p", _hoisted_29, _toDisplayString($data.order_detail.postage_order_no), 1), _withDirectives(_createElementVNode("input", {
    type: "hidden",
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.order_detail.postage_order_no = $event)
  }, null, 512), [[_vModelText, $data.order_detail.postage_order_no]]), _createElementVNode("div", {
    class: "copy",
    onClick: _cache[1] || (_cache[1] = _withModifiers((...args) => $options.copy && $options.copy(...args), ["stop"])),
    ref: "copyboard",
    copyData: $data.order_detail.postage_order_no
  }, "复制", 8, _hoisted_30)])) : _createCommentVNode("", true), $data.order_detail.apply_deliver_goods_time ? (_openBlock(), _createElementBlock("div", _hoisted_31, [_hoisted_32, _createElementVNode("p", null, _toDisplayString($data.order_detail.apply_deliver_goods_time), 1)])) : _createCommentVNode("", true), $data.order_detail.pay_success_time ? (_openBlock(), _createElementBlock("div", _hoisted_33, [_hoisted_34, _createElementVNode("p", null, _toDisplayString($data.order_detail.pay_success_time), 1)])) : _createCommentVNode("", true), $data.order_detail.payment_method ? (_openBlock(), _createElementBlock("div", _hoisted_35, [_hoisted_36, _createElementVNode("p", null, _toDisplayString($data.order_detail.payment_method == 'alipay' ? '支付宝' : '微信'), 1)])) : _createCommentVNode("", true), $data.order_detail.payment_flow ? (_openBlock(), _createElementBlock("div", _hoisted_37, [_hoisted_38, _createElementVNode("p", null, _toDisplayString($data.order_detail.payment_flow), 1)])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_39, [_createElementVNode("div", _hoisted_40, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.order_detail.buttons, (btn, btnIndex) => {
    return _openBlock(), _createElementBlock("div", {
      class: _normalizeClass(['btn', {
        'pay': btn.type == 'to_pay'
      }]),
      key: btnIndex,
      onClick: _withModifiers($event => $options.opOrder(btn.type, _ctx.item), ["stop"])
    }, _toDisplayString(btn.title), 11, _hoisted_41);
  }), 128))])]), _createVNode(_component_BigImage, {
    show: $data.bigImageVisible,
    init: $data.bigInitIndex,
    list: $data.bigList,
    onClose: _cache[2] || (_cache[2] = $event => $data.bigImageVisible = false)
  }, null, 8, ["show", "init", "list"]), _createVNode(_component_van_action_sheet, {
    show: $data.deliverVisible,
    "onUpdate:show": _cache[7] || (_cache[7] = $event => $data.deliverVisible = $event),
    title: "支付确认",
    "close-icon": $data.closeIcon
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_42, [_createElementVNode("div", _hoisted_43, [!$data.env.isWeixin() && !$data.env.isWeibo() ? (_openBlock(), _createElementBlock("div", _hoisted_44, [!$data.env.isWxApp() ? (_openBlock(), _createElementBlock("div", {
      key: 0,
      onClick: _cache[3] || (_cache[3] = $event => $options.clickfn('weixin_mina')),
      class: "item"
    }, [_hoisted_45, _createElementVNode("i", {
      class: _normalizeClass(['iconfont', {
        active: $data.pay_resource == 'weixin_mina'
      }, $data.pay_resource == 'weixin_mina' ? 'icon-singleselect' : 'icon-singleunselected'])
    }, null, 2)])) : _createCommentVNode("", true), !$data.env.isWeixin() ? (_openBlock(), _createElementBlock("div", {
      key: 1,
      onClick: _cache[4] || (_cache[4] = $event => $options.clickfn('alipay')),
      class: "item"
    }, [_hoisted_46, _createElementVNode("i", {
      class: _normalizeClass(['iconfont', {
        active: $data.pay_resource == 'alipay'
      }, $data.pay_resource == 'alipay' ? 'icon-singleselect' : 'icon-singleunselected'])
    }, null, 2)])) : _createCommentVNode("", true)])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_47, [_createElementVNode("div", {
      class: "cancel",
      onClick: _cache[5] || (_cache[5] = _withModifiers($event => $data.deliverVisible = false, ["stop"]))
    }, "取消"), _createElementVNode("div", {
      onClick: _cache[6] || (_cache[6] = _withModifiers((...args) => $options.confirmPay && $options.confirmPay(...args), ["stop"]))
    }, "确认支付")])])]),
    _: 1
  }, 8, ["show", "close-icon"]), _createElementVNode("div", {
    class: "html",
    ref: "html",
    innerHTML: $data.html
  }, null, 8, _hoisted_48), _createElementVNode("iframe", {
    style: {
      "width": "0",
      "height": "0",
      "position": "absolute",
      "opacity": "0",
      "z-index": "-1"
    },
    id: "webActivityShow",
    class: "dragArea list-group iphone-dragArea",
    src: $data.iframeUrl
  }, null, 8, _hoisted_49)], 2));
}